import React, { useMemo } from 'react';
import { Polyline, Marker } from 'react-leaflet';
import L from 'leaflet';
import { FACTORY_MAP_IMAGE_WIDTH, FACTORY_MAP_IMAGE_HEIGHT } from './qualityFactoryMapConfig';

const MINOR_STEP = 500;
const MAJOR_STEP = 1000;

function buildTicks(max, step) {
  const ticks = [];
  for (let v = 0; v <= max; v += step) ticks.push(v);
  return ticks;
}

function axisLabelIcon(text, orientation) {
  const baseStyle = [
    'font-size:10px', 'font-weight:700', 'color:#2c7be5',
    'background:rgba(255,255,255,0.85)', 'padding:1px 4px', 'border-radius:2px',
    'pointer-events:none', 'white-space:nowrap'
  ];
  if (orientation === 'top') {
    return L.divIcon({
      className: 'quality-grid-label-icon',
      html: `<div style="${baseStyle.join(';')}">${text}</div>`,
      iconSize: [40, 14],
      iconAnchor: [20, -2]
    });
  }
  return L.divIcon({
    className: 'quality-grid-label-icon',
    html: `<div style="${baseStyle.join(';')}">${text}</div>`,
    iconSize: [40, 14],
    iconAnchor: [-2, 7]
  });
}

export default function QualityCoordinateGrid() {
  const xTicks = useMemo(() => buildTicks(FACTORY_MAP_IMAGE_WIDTH, MINOR_STEP), []);
  const yTicks = useMemo(() => buildTicks(FACTORY_MAP_IMAGE_HEIGHT, MINOR_STEP), []);

  return (
    <>
      {xTicks.map(x => {
        const isMajor = x % MAJOR_STEP === 0;
        return (
          <React.Fragment key={`vx-${x}`}>
            <Polyline
              positions={[[0, x], [FACTORY_MAP_IMAGE_HEIGHT, x]]}
              interactive={false}
              pathOptions={{
                color: '#2c7be5',
                weight: isMajor ? 1 : 0.5,
                opacity: isMajor ? 0.55 : 0.25
              }}
            />
            {isMajor && (
              <Marker
                position={[FACTORY_MAP_IMAGE_HEIGHT, x]}
                icon={axisLabelIcon(x, 'top')}
                interactive={false}
                keyboard={false}
              />
            )}
          </React.Fragment>
        );
      })}
      {yTicks.map(y => {
        const isMajor = y % MAJOR_STEP === 0;
        return (
          <React.Fragment key={`hy-${y}`}>
            <Polyline
              positions={[[y, 0], [y, FACTORY_MAP_IMAGE_WIDTH]]}
              interactive={false}
              pathOptions={{
                color: '#2c7be5',
                weight: isMajor ? 1 : 0.5,
                opacity: isMajor ? 0.55 : 0.25
              }}
            />
            {isMajor && (
              <Marker
                position={[y, 0]}
                icon={axisLabelIcon(y, 'left')}
                interactive={false}
                keyboard={false}
              />
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}
